const moveCaret = (pos) => {
  const input = document.activeElement;
  setTimeout(() => {
    input.setSelectionRange(pos, pos);
  }, 10);
};
const normalizePhone = (value, previousValue) => {
  if (!value) {
    return value;
  }

  // document.activeElement && document.activeElement.nodeName === 'INPUT'
  const onlyNums = value.replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      moveCaret(4);
      return `${onlyNums}-`;
    }
    if (onlyNums.length === 6) {
      moveCaret(8);
      return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}-`;
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export const formatPhone = (value) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  return `(${onlyNums.slice(0, 3)})${onlyNums.slice(3, 6)}-${onlyNums.slice(6)}`;
};

export default normalizePhone;



// WEBPACK FOOTER //
// ./src/helpers/normalizePhone.js